export const environment = {
  production: false,
  environment: 'development',
  // Strapi via APIMAZ Gateway (QA)
  //strapiUrl: 'https://apimazqa.grupokaufmann.com/qas/v1/strapifoton',
  strapiUrl: 'https://apimaz.grupokaufmann.com/prd/v1/strapifoton',
  // CRM Cotizador Web (QA)
  //crmCotizadorUrl: 'https://apimazqa.grupokaufmann.com/qas/crm/oportunidad/v1/cotizador/web/async',
  crmCotizadorUrl: 'https://apimaz.grupokaufmann.com/prd/crm/oportunidad/v1/cotizador/web/async',
  // APIMAZ Subscription Key (QA/DEV)
  /* apimaz: {
    subscriptionKey: 'f40c97222d72486b9a35670a03fcad03',
    headerKey: 'Ocp-Apim-Subscription-Key'
  } */
  apimaz: {
    subscriptionKey: 'a85214f7dda445bfbabece68e74d43cb',
    headerKey: 'Ocp-Apim-Subscription-Key'
  }
};
